import { Card, Stack } from "@mui/material";
import TextEditorControls from "components/form/TextEditorControl";
import TextFieldControl from "components/form/TextFieldControl";
import typography from "constants/typography.constants";
import { useFormContext } from "react-hook-form";
import { Question_Type } from "@generated/graphql";
import useIsCreate from "hooks/useIsCreate";
import { QuestionInputs } from "../../types";
import GenerationField from "../GenerationField";

interface ContentAnswerProps {
  isEditing: boolean;
  skillId: string | undefined;
}

const ContentAnswer = ({ isEditing, skillId }: ContentAnswerProps) => {
  const isCreate = useIsCreate();
  const form = useFormContext<QuestionInputs>();
  const { watch, setValue } = form;
  const questionType = watch("type");
  const isMultiChoiceQuestion = questionType?.id === Question_Type.MultipleChoiceQuestions;

  const onChangeMinutes = (value: number) => {
    setValue("time", String(value >= 1 ? value : 1));
  };

  return (
    <Card>
      <Stack spacing={2}>
        {!isMultiChoiceQuestion && (
          <TextEditorControls
            name='referenceAnswer'
            disabled={!isEditing}
            label='Текст эталонного ответа'
            placeholder={typography.form.placeholder.text}
            rules={{ required: true }}
          />
        )}
        <Stack
          direction='row'
          spacing={2.5}>
          <TextFieldControl
            stackSx={{ width: "50%" }}
            rules={{
              validate: (value: number) => (!!value && !Number.isNaN(value) ? value > 0 : false),
            }}
            name='time'
            label='Время ответа'
            disabled={!isEditing}
            handleChange={(value: string, onChange) => onChange(value.replace(/\D/g, "").trim())}
            type='number'
            onNumberValueChange={onChangeMinutes}
          />
          {!isCreate && (
            <TextFieldControl
              stackSx={{ width: "50%" }}
              name='recommendedTime'
              label='Рекомендуемое время ответа'
              disabled
            />
          )}
        </Stack>
        {!isMultiChoiceQuestion && (
          <GenerationField
            name='answerComment'
            label='Комментарий к эталонному ответу'
            successText='Эталонный ответ сгенерирован'
            generationType='referenceAnswer'
            skillId={skillId}
            isEditing={isEditing}
          />
        )}
      </Stack>
    </Card>
  );
};

export default ContentAnswer;
